<template>
  <div class="container">
    <nyTit1 pathUrl="/pinpaiyichang" />
      <div class="content">
        <!-- 左 -->
        <div class="leftBox">
          <!-- 标题 -->
          <div class="title">
            <img src="../assets/img/sanchan2/tit1.png" class="img1" />
            <img src="../assets/img/sanchan2/tit2.png" class="img2" />
            <span>实力二产</span>
            <img src="../assets/img/sanchan2/tit3.png"  class="img3" />
          </div>
          <!-- 内容 -->
          <div class="left_bottm">
            <div class="leftContent1">
              <div class="left_txt"  v-on:mouseover="changeActive(0)" v-on:mouseout="removeActive(0)">
                <div class="txtBox"><span>{{left1Txt.name}}：</span>{{left1Txt.intro}}</div>
                <div class="left_txt_line"><div class="left_txt_line1_line"></div><img src="../assets/img/sanchan2/titIcon.png" class="title1_img2" /></div>
                <bigFont leftMargin="90%" topMargin="0" :txt="left1Txt.intro" :title="left1Txt.name" :isShow="curIndex[0]"  />
              </div>
              <div class="leftContent1_r">
                <!-- 标题 -->
                <div class="title1">
                    <div class="title1_l"><img src="../assets/img/sanchan2/jiantou.png" class="title1_img1" />
                    <span>主导产业情况</span></div>
                    <div class="title1_r"><div class="title1_line"></div><img src="../assets/img/sanchan2/titIcon.png" class="title1_img2" /></div>
                </div>
                <!-- 内容 -->
                <div class="leftContent1_r_content">
<!--                  <div class="leftContent1_r_content_l"><leftBar /></div>-->
                  <div class="leftContent1_r_content_r"><leftPie /></div>
                </div>
              </div>
            </div>
            <div class="leftContent2">
              <div class="left_txt" v-on:mouseover="changeActive(1)" v-on:mouseout="removeActive(1)">
                <div class="txtBox"><span>{{left2Txt.name}}：</span>{{left2Txt.intro}}</div>
                <div class="left_txt_line"><div class="left_txt_line1_line"></div><img src="../assets/img/sanchan2/titIcon.png" class="title1_img2" /></div>
                <bigFont leftMargin="90%" topMargin="0" :txt="left2Txt.intro" :title="left2Txt.name" :isShow="curIndex[1]"  />
              </div>
              <div class="leftContent2_r">
                <!-- 标题 -->
                <div class="title1">
                    <div class="title1_l"><img src="../assets/img/sanchan2/jiantou.png" class="title1_img1" />
                    <span>开发区规模</span></div>
                    <div class="title1_r"><div class="title1_line"></div><img src="../assets/img/sanchan2/titIcon.png" class="title1_img2" /></div>
                </div>
                <!--  -->
                <div class="leftContent2_r_content">
                  <div class="leftContent2_r_content_item" v-for="(item,index) in left2Data1" :key="index">
                    <img :src="item.icon" />
                    <div class="leftContent1_item_r"><span class="leftContent1_item_r_name">{{item.name}}</span><span class="leftContent1_item_r_value">{{item.value}}<i>{{item.unit}}</i></span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="leftContent3">
              <div class="left_txt" v-on:mouseover="changeActive(2)" v-on:mouseout="removeActive(2)">
                <div class="txtBox"><span>{{left3Txt.name}}：</span>{{left3Txt.intro}}</div>
                <bigFont leftMargin="90%" topMargin="-60%" :txt="left3Txt.intro" :title="left3Txt.name" :isShow="curIndex[2]"  />
              </div>
              <div class="leftContent3_r">
                <!-- 标题 -->
                <div class="title1">
                    <div class="title1_l"><img src="../assets/img/sanchan2/jiantou.png" class="title1_img1" />
                    <span>科技创新情况</span></div>
                    <div class="title1_r"><div class="title1_line"></div><img src="../assets/img/sanchan2/titIcon.png" class="title1_img2" /></div>
                </div>
                <!--  -->
                <div class="leftContent3_r_content">
                  <div class="leftContent3_r_content_l"><leftLine2 :data="left3Data1" /></div>
                  <div class="leftContent3_r_content_r">
                    <div class="leftContent3_r_content_r_item" v-for="(item,index) in left3Data2" :key="index">
                      <span class="index">{{index+1}}</span><span class="font">{{item}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> 
         <!--中间-->
        <div class="center">
            <div class="videoBox">
              <div class="videoBox_item" v-for="(item,index) in center_data" :key="index" @click="videoClick(index,item.type)">
                <img :src="item.img" />
                <div class="video_tit">{{item.name}}</div>
              </div>
            </div>
        </div>
        <!-- 右侧 -->
        <div class="rightBox">
          <!-- 全县2023年工业总产值 -->
            <div class="rightBox1">
              <div class="title">
                <img src="../assets/img/sanchan2/tit1.png" class="img1" />
                <img src="../assets/img/sanchan2/tit2.png" class="img2" />
                <span>全县2024年工业总产值</span>
                <img src="../assets/img/sanchan2/tit3.png"  class="img3" />
              </div>
              <div class="rightBox1_content">
                <div class="rightBox1_content_item" v-for="(item,index) in config" :key="index"><dv-scroll-board :config="item" style="width:100%;height:100%" /></div>
              </div>
            </div>
            <!-- 优秀企业2023年产值 -->
            <div class="rightBox2">
              <div class="title">
                <img src="../assets/img/sanchan2/tit1.png" class="img1" />
                <img src="../assets/img/sanchan2/tit2.png" class="img2" />
                <span>优秀企业2023年产值</span>
                <img src="../assets/img/sanchan2/tit3.png"  class="img3" />
              </div>
              <div class="rightBox2_content">
                  <div class="rightBox2_content_item" v-for="(item,index) in rightData2" :key="index">
                    <h2>{{item.name}}</h2>
                    <div class="rightBox2_content_item_bottom">
                      <img :src="item.icon" />
                      <div class="rightBox2_content_item_bottom_r">
                        <span>{{item.value}}</span>
                        <span>{{item.unit}}</span>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
      </div>
  </div>
   <footer1 />
   <popBg v-if="popShow" :title="center_data[curVideoIndex].name" :popShow="popShow"
          :code="center_data[curVideoIndex].code" @hiddlen="popHiddlen">
     <div style=" width: 100%;height: 100%" v-if="videotype===1">
        <vue3VideoPlay id="video"  width="100%"  height="100%"  title="冰河世纪"  :src="center_data[curVideoIndex].options.src"  :type="center_data[curVideoIndex].options.type"  :autoPlay="true"/>
     </div>
     <div style=" width: 100%;height: 100%" v-else>
       <iframe :src="center_data[curVideoIndex].options.src+AccessToken" width="100%" height="100%" id="ysOpenDevice" allowfullscreen></iframe>
     </div>
   </popBg>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import * as THREE from 'three';
import { useRouter } from 'vue-router'
import countTo from"@/components/vue-count-to/src/vue-countTo.vue"
import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
  inject
} from "vue";
// 



import leftBar from "@/components/sanchan2/left_bar"
import leftPie from "@/components/sanchan2/left_pie"
import leftLine2 from "@/components/sanchan2/left_line2"
import popBg from "../components/popBg.vue"
import footer1 from "../components/footer.vue";
import bigFont from '../components/bigFont.vue'
import nyTit1 from "@/components/nyTit1.vue";


export default {
  name: "Home",
  setup() {
    const { appContext  } = getCurrentInstance();
    // const timer = ref(null);
    const router = useRouter();
    // const AccessToken = inject('AccessToken')
    const state = reactive({
      url:"https://lcamapp.oss-accelerate.aliyuncs.com/uploads/img",
      left1Txt:{name:"主导产业集群集聚",intro:"纺织服装制鞋产业链条不断壮大，已入驻隆祺、金帝、荣辉等骨干企业60余家，建成河南省鞋类产品质量监督检验中心，“中原鞋都”建设蔚然成势。农副产品加工构建新格局，入驻上农实业、闽商食品工业园等骨干企业30多家，培育出“旷华食品”盛世粮油”等一批知名品牌。电子电器产业初具规模，入驻兰迪光电、沃诚电子等企业15家。"},
      left2Txt:{name:"园区能级显著提升",intro:"深化推进开发区“三化三制”改革，收购盘活土地1635亩，总资产达20亿元，实现总产值150亿元。大力实施标准化厂房建设，新建65万平方米标准化厂房，盘活改造智能制鞋产业园等闲置厂房30万平方米，成功吸引红柳树纺织、聚邦纺织等一批企业实现“拎包入住”"},
      left3Txt:{name:"创新能力不断提高:",intro:"坚定走好创新驱动高质量发展这个“华山一条路”，下好科技赋能“先手棋”。培育国家高新技术企业29家，建成河南省工程技术研究中心16个，56家企业与高等院校及科研院所签订了产学研合作协议，累计申请专利1326项。"},
      curIndex:[false,false,false],
      videotype:1,
      left2Data1:[
        {name:"规划面积",value:"10.45",unit:"平方千米",icon:require("../assets/img/sanchan2/left1Icon1.png")},
        {name:"建成区面积",value:"5.81",unit:"平方公里",icon:require("../assets/img/sanchan2/left1Icon2.png")},
        {name:"入住企业",value:"331",unit:"个",icon:require("../assets/img/sanchan2/left1Icon3.png")},
        {name:"规模以上企业",value:"223",unit:"个",icon:require("../assets/img/sanchan2/left1Icon1.png")},
        {name:"从业人员",value:"30000",unit:"人",icon:require("../assets/img/sanchan2/left1Icon2.png")},
        {name:"标准化厂房面积",value:"100",unit:"万平方米",icon:require("../assets/img/sanchan2/left1Icon3.png")},
      ],
      left3Data1:[["2019","2020","2021","2022","2023"],["7146.5","8792.3","11860.6","12792.3","13059.4"]],
      // ["21860.6","12792.3","13059.4]"]
      left3Data2:["博士后创新实践基地1个","国家高新技术企业29家","河南省工程技术研究中心16个","累计申请专利1326项","5G基站75个","企业上云150个"],
      config:[
        {                
        header: ['项目', '产值（亿）', '企业数量'],
        data: [
          ['全县加工业总值','266','374'],
          ['农产品加工企业','40','174'],
          ['纺织服装产业','8','55'],
        ],
        headerBGC:"rgba(20, 54, 102,.35)",
        oddRowBGC:"",
        evenRowBGC:"",
        headerHeight:60,
        align: ['center','center','center'],
        rowNum:3
      },
      {                
        header: ['项目', '产值（亿）', '企业数量'],
        data: [
          ['制鞋产业','40','73'],
          ['体育用品产业','2.5','17'],
          ['电子电器','4','55'],
        ],
        headerBGC:"rgba(20, 54, 102,.35)",
        oddRowBGC:"",
        evenRowBGC:"",
        headerHeight:60,
        align: ['center','center','center'],
        rowNum:3
      },
      ],
      center_data:[
        {
          name:"上农实业",img:"https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_2_9/image/2-1.gif",
          type:1,
          options:{
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_2_9/1.shangnongshiye.mp4", //视频源
            type: 'video/mp4', //视频类型
          },
        },{
          name:"久久农科",img:"https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_2_9/image/2-2.gif",
          type:2,
          // options:{
          //   src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_2_9/2.jiujiunongke.mp4", //视频源
          //   type: 'video/mp4', //视频类型
          // },
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ9924584/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"AZ9924584"
        },
        // {
        //   name:"状元红酒业",img:"https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_2_9/image/2-3.gif",
        //   options:{
        //     src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_2_9/3.zhuangyuanhongjiuchang.mp4", //视频源
        //     type: 'video/mp4', //视频类型
        //   },
        // },
          {
          name: "旷华食品 ",
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/image/3c-2-5.gif",
            type:1,
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/khsp.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        
        {
          name:"聚邦纺织",img:"https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_2_9/image/2-4.gif",
          type:1,
          options:{
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_2_9/4.jubangzhifang.mp4", //视频源
            type: 'video/mp4', //视频类型
          },
        }, {
          name:"金帝鞋业",img:"https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/shangcaishiping/ronghechanye_2_9/image/jdxy.gif",
          type:2,
          // options:{
          //   src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_2_9/jdxy.mp4", //视频源
          //   type: 'video/mp4', //视频类型
          // },
          options: {
            src: "https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ8538404/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"AZ8538404"
        },{
        //   name:"荣辉鞋业",img:"https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_2_9/image/2-6.gif",
        //   type:1,
        //   options:{
        //     src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_2_9/6.longqixieye.mp4", //视频源
        //     type: 'video/mp4', //视频类型
        //   },

          name:"荣辉鞋业",img:"https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/sxt/19.png",
          type:2,
          options:{
            src: "https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ9924583/1.live&autoplay=1&accessToken=", //视频源
            type: 'm3u8', //视频类型
          },
          code:"AZ9924583"
        },
        {
          name:"菌速体育",img:"https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_2_9/image/2-7.gif",
          type:1,
          options:{
            src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/shangcaishiping/ronghechanye_2_9/ysty.mp4", //视频源
            type: 'video/mp4', //视频类型
          },
          // options: {
          //   src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ8538196/1.live&autoplay=1&accessToken="+AccessToken, //视频源
          //   type: "m3u8", //视频类型
          // },
        },{
          name:"兰迪光电",img:"https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_2_9/image/2-8.gif",
          type:2,
          // options:{
          //   src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_2_9/ldgd.mp4", //视频源
          //   type: 'video/mp4', //视频类型
          // },
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ9924736/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"AZ9924736"
        },{
          name:"臻美印象",img:"https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_2_9/image/2-9.gif",
          type:1,
          options:{
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_2_9/9.zhimeiyinxiang.mp4", //视频源
            type: 'video/mp4', //视频类型
          },
        },
      ],
      rightData2:[
        {name:"河南上农实业有限公司",value:12,unit:"亿元",icon:require("../assets/img/sanchan2/icon1.png")},
        {name:"河南久久农业科技有限公司",value:6,unit:"亿元",icon:require("../assets/img/sanchan2/icon3.png")},
        {name:"河南牛硕乳业有限公司",value:7000,unit:"万元",icon:require("../assets/img/sanchan2/icon2.png")},
        {name:"河南聚邦纺织科技有限公司",value:5,unit:"亿元",icon:require("../assets/img/sanchan2/icon4.png")},
        {name:"驻马店豫锦时装有限公司",value:6800,unit:"万元",icon:require("../assets/img/sanchan2/icon1.png")},
        {name:"河南隆祺鞋业有限公司",value:2,unit:"亿元",icon:require("../assets/img/sanchan2/icon3.png")},
        {name:"驻马店金帝鞋业有限公司",value:6,unit:"亿元",icon:require("../assets/img/sanchan2/icon2.png")},
        {name:"河南荣辉鞋业有限公司",value:3,unit:"亿元",icon:require("../assets/img/sanchan2/icon4.png")},
        {name:"河南茵速体育用品有限公司",value:1.1,unit:"亿元",icon:require("../assets/img/sanchan2/icon1.png")},
        {name:"河南三公利华体育科技有限公司",value:9297,unit:"万元",icon:require("../assets/img/sanchan2/icon3.png")},
        {name:"河南兰迪光电科技有限公司",value:3.5,unit:"亿元",icon:require("../assets/img/sanchan2/icon2.png")},
        {name:"河南臻美印象科技有限公司",value:"3750",unit:"万元",icon:require("../assets/img/sanchan2/icon4.png")}
      ],
      popShow:false,
      curVideoIndex:0,
      AccessToken:""
    });
     onMounted(() => {
      // setInterval(() => {
      //   state.showDiv = !state.showDiv
      // }, 6000);
       state.AccessToken = localStorage.getItem('AccessToken')
    })
    onUnmounted(() => {
      
      
    });
    onBeforeUnmount(() => {
     
    })
    function removeActive(num){
      state.curIndex[num]= false
    }
    function changeActive(num){
      console.log(num)
     state.curIndex[num]=true
     console.log(state.curIndex)
    }
     // 返回上一页
    function clickReturn(){
        router.go(-1);
    }
    function tabcp(e){
      console.log(e.rowIndex)
    }
    // 弹出视频
    function videoClick(index1,types){
      console.log(index1)
      state.popShow = true
      state.curVideoIndex = index1
      state.videotype = types;
    }
    // 关闭弹出
    function popHiddlen(){
      state.popShow = false
    }
    return {
      ...toRefs(state),
      close,
      clickReturn,
      tabcp,
      videoClick,
      popHiddlen,
      removeActive,
      changeActive
    };
  },
  components: {
    nyTit1,

      leftBar,
      leftPie,
      leftLine2,
      popBg,
      footer1,
      bigFont
     
  },
};
</script>
<style lang="less" scoped>
a{color: #fff;}
body {
  background-size: cover;
  line-height: 1.15;
}
@font-face {
  font-family: electronicFont;
  src: url("../assets/font/DS-DIGIT.TTF");
}

#video .d-player-wrap {
  object-fit: cover;
  // background-color: #ff0000 !important;
  background-color: transparent !important; /* 设置背景色为透明 */
}

// 修改右侧产品带货列表列表样式
::v-deep .dv-scroll-board .rows .row-item,::v-deep .dv-scroll-board .header .header-item{
  font-size: 26px;
  cursor: pointer;
}
// ::v-deep .dv-scroll-board .header .header-item{
//   border-bottom: 1px solid rgba(255,255,255,.2);
// }
.container{
  width: 100%;
  height: 100%;
  background: #010A1E;
  background-size: 100% 100%!important;
  color: #fff;
  position: relative;
  .content{
    position: absolute;
    top: 182px;
    left: 0;
    width: 100%;
    height: calc(100% - 182px);
    display: flex;
    position: relative;
    padding: 0 45px 40px;
    box-sizing: border-box;
    // 左侧
    .leftBox,.rightBox{
      width: 1903px;
    }
    .leftBox{
      height: 100%;
      background:url("../assets/img/sanchan2/leftBg.png") no-repeat ;
      background-size: 100% 100%!important;
      display: flex;
      flex-direction: column;
      .left_bottm{
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        padding-top:20px;
        box-sizing: border-box;
        .left_txt{
          width: 700px;
          height: 100%;
          // border: 1px solid;
          padding: 40px 0 0 0;
          display: flex;
          flex-direction: column;
          box-sizing: border-box;
          position: relative;
          .txtBox{
            padding: 0 20px;
            color: rgba(255,255,255,.8);
            font-size: 30px;
            line-height: 56px;
            text-align: left;
            span{
              font-weight: bold;
              color: #fff;
            }
            overflow-y: hidden;
          }
          .left_txt_line{
            display: flex;
            align-items: center;
            margin-top: 40px;
            .left_txt_line1_line{
              flex: 1;
              height: 4px;
              background: #132B54;
              margin: 0 50px 0 0;
            }
          }
        }
        .leftContent1_r,.leftContent2_r,.leftContent3_r{
          flex: 1;
          margin: 0 50px;
          box-sizing: border-box;
        }
        .leftContent1,.leftContent2,.leftContent3{
          display: flex;

        }
        .leftContent1{
          height: 460px;
          .leftContent1_r{
            padding-top: 20px;
            width: 100%;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            .leftContent1_r_content{
              width: 100%;
              flex: 1;
              display: flex;
              .leftContent1_r_content_l{
                width: 625px;
              }
              .leftContent1_r_content_r{
                flex: 1;
                height: 100%;
              }
            }
          }
        }
        .leftContent2{
          height: 393px;
          display: flex;
          // border: 1px solid;
          .leftContent2_r{
            display: flex;
            flex-direction: column;
            height: 100%;
            .leftContent2_r_content{
              width: 100%;
              flex: 1;
              display: flex;
              flex-wrap: wrap;
              justify-content: space-between;
              align-items: center;
              padding: 40px 20px;
              box-sizing: border-box;
              .leftContent2_r_content_item{
                width: 32%;
                display: flex;
                align-items: center;
                // margin: 20px 0;
                // border: 1px solid;
                img{
                  width: 91px;
                  height: 91px;
                  margin-right: 20px;
                }
                .leftContent1_item_r{
                  text-align: left;
                  span{
                    display: block;
                  }
                  .leftContent1_item_r_name{
                    font-size: 24px;
                    color: #AEB2B6;
                    margin-bottom: 5px;
                  }
                  .leftContent1_item_r_value{
                    font-weight: bold;
                    font-size: 36px;
                    i{
                      font-style: normal;
                      font-weight: normal;
                      font-size: 26px;
                      margin-left: 10px;
                    }
                  }
                }
              }
            }
          }
        }
        .leftContent3{
          flex: 1;
          .leftContent3_r{
            display: flex;
            flex-direction: column;
            .leftContent3_r_content{
              width: 100%;
              flex: 1;
              display: flex;
              justify-content: space-between;
              .leftContent3_r_content_l{
                flex: 1;
              }
              .leftContent3_r_content_r{
                 width: 42%;
                text-align: left;
                // border: 1px solid;
                .leftContent3_r_content_r_item{
                  width: 100%;
                  display: flex;
                  line-height: 25px;
                  margin-bottom: 14px;
                  justify-content: flex-end;
                  .index{
                    display: block;
                    width: 56px;
                    height: 50px;
                    border: 2px solid #03AFE5;
                    line-height: 50px;
                    font-size: 30px;
                    text-align: center;
                    box-shadow: inset 0 0 12px 12px rgba(3, 175, 229, 0.5);
                    font-weight: bold;
                    margin-right: 20px;
                  }
                  .font{
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    line-height: 34px;
                    font-size: 28px;
                  }
                }
              }
            }
          }
        }
      }
      .leftBox1{
        width: 100%;
        height: 438px;
        display: flex;
        flex-direction: column;
        .leftContent1{
          width: 100%;
          flex: 1;
          display: flex;
          justify-content: space-between;
          padding: 0 100px;
          box-sizing: border-box;
          font-size: 40px;
          .leftContent1_item{
            display: flex;
            align-items: center;
            img{
              width: 147px;
              height: 146px;
              margin-right: 50px;
            }
            .leftContent1_item_r{
              text-align: left;
              span{
                display: block;
              }
              .leftContent1_item_r_name{
                font-size: 30px;
                color: #AEB2B6;
                margin-bottom: 10px;
              }
              .leftContent1_item_r_value{
                font-weight: bold;
                i{
                  font-style: normal;
                  font-weight: normal;
                  font-size: 30px;
                  margin-left: 10px;
                }
              }
            }
          }
        }
        
      }
      .leftBox2{
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        .leftBox2_a{
          height: 200px;
          display: flex;
          justify-content: space-between;
          padding: 0 50px;
          align-items: center;
          .leftBox2_a_item{
              text-align: left;
              flex: 1;
              .name{
                font-size: 36px;
                i{
                  color: #4EFAE7;
                  font-size: 30px;
                  margin-left: 16px;
                  font-style: normal;
                }
              }
              .value{
                font-size: 50px;
                color: #4EFAE7;
                margin-top: 10px;
                font-weight: bold;
              }
              
          }
        }
        .leftBox2_b{
          height: 400px;
          padding: 0 50px;
          display: flex;
          justify-content: space-between;
          .leftBox2_b_a{
            width: 48%;
            display: flex;
            flex-direction: column;
          }
        }
         .leftBox2_c{
          flex: 1;
          padding: 0 50px;
          display: flex;
          flex-direction: column;
          .title1{
            width: 50%;
          }
        }
      }
      .title{  
        margin-right: 2%;
      }
    }
    .center{
      flex: 1;
      flex-shrink: 0;
      height: 100%;
      padding-top: 100px;
      box-sizing: border-box;
      display: flex;
      margin: 0 120px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .videoBox{
        width: 100%;
        height: 100%;
        border: 1px solid #143666;
        display: flex;
        flex-wrap: wrap;
        padding: 36px 50px;
        box-sizing: border-box;
        justify-content: space-between;
        align-content: space-between;
        .videoBox_item{
          width: 672px;
          height: 388px;
          position: relative;
          img{
            width: 100%;
            height: 100%;
            display: block;
          }
          .video_tit{
            position: absolute;
            left: 0;
            bottom: 0;
            background: rgba(20,54,102,.6);
            width: 100%;
            height: 60px;
            line-height: 60px;
            overflow: hidden;
            font-size: 30px;
          }
        }
      }
    }
    // 右側
    .rightBox{
      height: 100%;
      display: flex;
      flex-direction: column;
      background:url("../assets/img/sanchan2/rightBg.png") no-repeat ;
      background-size: 100% 100%!important;
      .rightBox1{
        width: 100%;
        height:474px ;
        display: flex;
        flex-direction: column;
        .rightBox1_content{
          display: flex;
          width: 100%;
          flex: 1;
          padding: 50px 0;
          box-sizing: border-box;
          .rightBox1_content_item{
            width: 50%;
            height: 100%;
            padding: 0 50px;
            box-sizing: border-box;
          }
        }
        
      }
      .rightBox2{
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        .rightBox2_content{
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          padding: 80px 50px 50px 80px;
          box-sizing: border-box;
          .rightBox2_content_item{
            width: 23%;
            h2{
              width: 100%;
              height: 60px;
              background: rgba(20,54,102,.35);
              font-weight: normal;
              font-size: 28px;
              line-height: 60px;
            }
            .rightBox2_content_item_bottom{
              display: flex;
              justify-content: center;
              align-items: center;
              margin-top: 50px;
              img{
                width: 121px;
                height: 87px;
              }
              .rightBox2_content_item_bottom_r{
                margin-left: 30px;
                span{
                  text-align: left;
                  display: block;
                }
                span:nth-child(1){
                  font-size: 46px;
                }
                span:nth-child(2){
                  color: #00CBFF;
                  font-size: 26px;
                  margin-top: 10px;
                  font-weight: bold;
                }
              }
            }
          } 
          // .rightBox2_content_item:last-child{
          //   .rightBox2_content_item_bottom{
          //     .rightBox2_content_item_bottom_r{
          //       span{
          //         font-size: 26px;
          //       }
          //     }
          //   }
          // }         
        }
      }
    }
    .echartBox{
      width: 100%;
      flex: 1;
    }

    // 标题
    .title{
      width: 98%;
      height: 60px;
      background:rgba(20,54,102,.6);
      text-align: left;
      line-height: 60px;
      display: flex;
      align-items: center;
      span{
        display: block;
        font-size: 32px;
        margin-right: 150px;
        margin-left: 20px;
      }
      .img1{
        width: 6px;
        height: 60px;
      }
      .img2{
        width: 56px;
        height: 56px;
      }
      .img3{
        width: 212px;
        height: 27px;
      }
    }
    .title1{
      width: 90%;
      height: 40px;
      display: flex;
      align-items: center;
      font-size: 32px;
      color: #01BDEA;
      font-weight: bold;
      justify-content: space-between;
      .title1_l{
        display: flex;
        align-items: center;
        .title1_img1{
          width: 25px;
          height: 31px;
          margin-right: 30px;
        }
      }
      .title1_r{
        display: flex;
        align-items: center;
        .title1_img2{
          width: 46px;
          height: 31px;
        }
        .title1_line{
          width: 210px;
          height: 4px;
          background: #132B54;
          margin: 0 30px 0 50px;
        }
      }
      
      
    }

  }
}


// 轨道旋转动画b
@keyframes spin {
  0% {
    transform: scaleY(0.5) rotate(0deg);
  }
  100% {
    transform: scaleY(0.5) rotate(360deg);
  }
}
@keyframes anti-spin {
  0% {
    transform: rotate(0deg) scaleY(2) scale(1);
  }
  100% {
    transform: rotate(-360deg) scaleY(2) scale(1);
  }
}
// 轨道


@keyframes scale1{
    0%{transform:scale(1)}
    50%{transform:scale(1.08);}
    100%{transform:scale(1)}
}
 @keyframes scale{
    0%{transform:scale(1)}
    50%,75%{transform:scale(2)}
    78%,100%{opacity:0}
}
@keyframes title {  
  0%{                     
      background-position: 0 bottom;
  } 
  50%{
    background-position: 10px bottom;
  }
   100%{
    background-position: 0 bottom;
  }
}
@keyframes bianda {  

  0%{                     
      // transform: scale(0.96);
      filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0));
  } 
  50%{
    // transform: scale(1);
    filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.5));
  }
   100%{
    // transform: scale(0.96);
    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0));
  }
}
@keyframes jiantou {  

  0%{                     
      right: 90px;
  } 

  50%{
    right: 95px;
  }
   100%{
    right: 90px;
  }
}

@keyframes guangying {  
 0%{                     
      transform: scale(0.96);
      filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
  } 

  50%{
    transform: scale(1);
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));
  }
   100%{
    transform: scale(0.96);
    filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
  }
}


@keyframes rightCircle { 
  0% {
          transform: rotate(0deg);
      }

  100% {
      transform: rotate(360deg);
  }
}

 @keyframes rotate {
    0% {
        transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg);
    }
    100% {
        transform: rotateX(0deg) rotateY(0deg) rotateZ(360deg);
    }
 }

// 左侧矩形
@keyframes leftJx {    /*引用动画名称*/
  0% {
          box-shadow: inset 0 0 5px 2px rgba(55, 199, 219, .5);
      }
  50% {
        box-shadow: inset 0 0 10px 2px rgba(55, 199, 219, .5);
    }

  100% {
      box-shadow: inset 0 0 5px 2px rgba(55, 199, 219, .5);
  }
}
</style>
